import * as React from "react";
import "./spinner.scss";
import classNames = require("classnames");

const spinner = require("./../../../../../resources/hiber/img/spinner-white.png");

interface IProps {
	/**
	 * Spinner image.
	 */
	imgUrl?: string;
	/**
	 * Spinner size.
	 */
	size?: number;
	/**
	 * Custom class.
	 */
	customClass?: string;
	/**
	 * Indicates if spinner should be display in center
	 */
	isCentered?: boolean;
}

export default class Spinner extends React.Component<IProps, {}> {

	public static defaultProps: Partial<IProps> = {
		imgUrl: spinner,
		size: 25,
		isCentered: true
	};

	render() {
		const classFromProps = classNames({
			"a-spinner": true,
			"center" : this.props.isCentered,
			[String(this.props.customClass)]: !!this.props.customClass,
		});
		return (
			<div className={classFromProps}>
				<img src={this.props.imgUrl} style={{width: `${this.props.size}px`, height: `${this.props.size}px`}}
					 className={"a-spinner_img"}/>
			</div>
		);
	}
}
